"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTransactions = exports.getServerInfo = exports.getAccountInfo = exports.submit = exports.parseAPIValue = exports.connectionTimeout = void 0;
const network_1 = __importDefault(require("@ledgerhq/live-network/network"));
const currencies_1 = require("../../../currencies");
const env_1 = require("../../../env");
const promise_1 = require("../../../promise");
const js_1 = require("../bridge/js");
const defaultEndpoint = () => (0, env_1.getEnv)("API_RIPPLE_RPC");
exports.connectionTimeout = 30 * 1000; // default connectionTimeout is 2s and make the specs bot failed
const rippleUnit = (0, currencies_1.getCryptoCurrencyById)("ripple").units[0];
const parseAPIValue = (value) => (0, currencies_1.parseCurrencyUnit)(rippleUnit, value);
exports.parseAPIValue = parseAPIValue;
const submit = (signature) => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield (0, network_1.default)({
        method: "POST",
        url: `${defaultEndpoint()}`,
        data: {
            method: "submit",
            params: [
                {
                    tx_blob: signature,
                },
            ],
        },
    });
    return res.data.result;
});
exports.submit = submit;
const getAccountInfo = (recipient, current) => __awaiter(void 0, void 0, void 0, function* () {
    const res = () => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield (0, network_1.default)({
            method: "POST",
            url: `${defaultEndpoint()}`,
            data: {
                method: "account_info",
                params: [
                    {
                        account: recipient,
                        ledger_index: current ? "current" : "validated",
                    },
                ],
            },
        });
        if (res.data.result.status !== "success" &&
            res.data.result.error !== js_1.NEW_ACCOUNT_ERROR_MESSAGE) {
            throw new Error(`couldn't fetch account info ${recipient}`);
        }
        return res.data.result;
    });
    return (0, promise_1.retry)(() => res(), {
        maxRetry: (0, env_1.getEnv)("GET_CALLS_RETRY"),
    });
});
exports.getAccountInfo = getAccountInfo;
const getServerInfo = (endpointConfig) => __awaiter(void 0, void 0, void 0, function* () {
    const res = () => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield (0, network_1.default)({
            method: "POST",
            url: endpointConfig !== null && endpointConfig !== void 0 ? endpointConfig : `${defaultEndpoint()}`,
            data: {
                method: "server_info",
                params: [
                    {
                        ledger_index: "validated",
                    },
                ],
            },
        });
        if (res.data.result.status !== "success") {
            throw new Error(`couldn't fetch server info`);
        }
        return res.data.result;
    });
    return (0, promise_1.retry)(() => res(), {
        maxRetry: (0, env_1.getEnv)("GET_CALLS_RETRY"),
    });
});
exports.getServerInfo = getServerInfo;
const getTransactions = (address, options) => __awaiter(void 0, void 0, void 0, function* () {
    const res = () => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield (0, network_1.default)({
            method: "POST",
            url: `${defaultEndpoint()}`,
            data: {
                method: "account_tx",
                params: [
                    Object.assign({ account: address, ledger_index: "validated" }, options),
                ],
            },
        });
        return res.data.result.transactions;
        if (res.data.result.status !== "success") {
            throw new Error(`couldn't getTransactions for ${address}`);
        }
    });
    return (0, promise_1.retry)(() => res(), {
        maxRetry: (0, env_1.getEnv)("GET_CALLS_RETRY"),
    });
});
exports.getTransactions = getTransactions;
function getLedgerIndex() {
    return __awaiter(this, void 0, void 0, function* () {
        const res = () => __awaiter(this, void 0, void 0, function* () {
            const ledgerResponse = yield (0, network_1.default)({
                method: "POST",
                url: `${defaultEndpoint()}`,
                data: {
                    method: "ledger",
                    params: [
                        {
                            ledger_index: "validated",
                        },
                    ],
                },
            });
            if (ledgerResponse.data.result.status !== "success") {
                throw new Error(`couldn't fetch getLedgerIndex`);
            }
            return ledgerResponse.data.result.ledger_index;
        });
        return (0, promise_1.retry)(() => res(), {
            maxRetry: (0, env_1.getEnv)("GET_CALLS_RETRY"),
        });
    });
}
exports.default = getLedgerIndex;
//# sourceMappingURL=index.js.map